import { useState } from 'react'
import { useAppContext } from '@/AppContext'
import { persistent } from '@/services/LocalStorage'
import useAnalytics from '@/services/useAnalytics'
import * as Constants from '@/services/Constants'
import { Card } from '../../Card'
import { CardHeader } from '../../CardHeader'
import TalkbackIcon from '@/CustomIcons/TalkbackIcon'
import { RadioGroup } from '@/UIComponents2/RadioGroup'
import { AnalyticsEvents } from '@/services/AnalyticsService'
import { Button } from '@/UIComponents2/Button'
import { makeTalkbackKeyDescriptionString } from '@/Logic'
import { Dialog } from '@/components/Dialog'
import ElectronIPC from '@/services/ElectronIPC'
import RecordKeyView from '@/pages/RecordKeyView'

export function TalkbackSection() {
    const [appState, appDispatch] = useAppContext()
    const { logUserActivityWithContext } = useAnalytics()
    const [showRecordKeyDialog, setShowRecordKeyDialog] = useState(false)
    const [currentKey, setCurrentKey] = useState(persistent.getObject(Constants.keyboardshortcut_talkback))

    return (
        <Card className="flex flex-col gap-[20px]">
            <CardHeader icon={TalkbackIcon} title="Talkback (Push to Talk)" />
            <div className="grid grid-cols-[1fr_1fr] gap-8 items-center pt-4">
                <div>Talkback Key Mode</div>
                <RadioGroup
                    className="flex flex-row gap-6"
                    items={[
                        { label: 'Hold down', value: 'hold' },
                        { label: 'Toggle', value: 'toggle' },
                    ]}
                    value={appState.appSettings.talkbackKeyMode}
                    onChange={(value) => {
                        if (value === 'toggle' || value === 'hold') {
                            appDispatch({
                                type: 'update_app_settings',
                                value: { talkbackKeyMode: value },
                            })
                            logUserActivityWithContext(AnalyticsEvents.CHANGED_TALKBACK_KEY_MODE, {
                                talkbackKeyMode: value,
                            })
                        }
                    }}
                />

                <div>Current Talkback Key</div>
                <div>
                    <Button variant="rectangle" className="rounded-[8px]" onClick={() => setShowRecordKeyDialog(true)}>
                        {makeTalkbackKeyDescriptionString(currentKey)}
                    </Button>
                </div>
            </div>

            {showRecordKeyDialog && (
                <Dialog
                    title="Set Talkback Key"
                    open={true}
                    portaled={false}
                    onClose={() => {
                        setShowRecordKeyDialog(false)
                        ElectronIPC.iohookSetMode('normal')
                    }}
                    zIndex={21}
                >
                    <RecordKeyView
                        onClose={() => {
                            setCurrentKey(persistent.getObject(Constants.keyboardshortcut_talkback))
                            setShowRecordKeyDialog(false)
                            ElectronIPC.iohookSetMode('normal')
                        }}
                    />
                </Dialog>
            )}
        </Card>
    )
}
